export const environment = {
  // apiBaseUrl:"http://localhost:5015",

  // Prod
  // apiBaseUrl: 'https://dmaprod-api.xenovex.com',
  // imageBaseUrl: 'https://dmaimages.xenovex.com',

  // Old Live
  // apiBaseUrl: 'https://dmaapi.xenovex.com',
  // imageBaseUrl: 'https://dmaimages.xenovex.com',

  // Dev
  apiBaseUrl: 'https://dmaprod-api.xenovex.com',
  imageBaseUrl: 'https://dmaimages.xenovex.com',

  tokenEndPoint: '/api/token',
  production: false,
  environment: 'Local',
  showEnvironment: true,
  StoppageIntervalSecs: 300,
};
